import styled from 'styled-components'

import { fonts, palette, setOpacity } from '../../../styles/variables'

export const Wrapper = styled.div((props) => ({
  height: props.height || '200px',
  border: props.maxTagsReached
    ? `1px solid ${palette.danger}`
    : `1px solid ${palette.lightGray50}`,
  borderRadius: '2px',
  padding: '8px 4px',
  cursor: 'text',
  overflow: 'scroll',
}))

export const ReactTagInputWrapper = styled.div({
  boxSizing: 'border-box',
  position: 'relative',
  width: '100%',
  height: 'auto',
  minHeight: '2.375em',
  padding: '0.1875em 0.375em',
  overflowY: 'auto',

  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',

  fontSize: '1rem',
  background: 'white',
  color: palette.darkGray,
  border: 'none',
  borderRadius: '3px',
  pointerEvents: 'all',

  '*': {
    boxSizing: 'border-box',
  },

  '> *': {
    margin: '0.1875em',
  },
})

export const ReactTagInputInput = styled.input((props) => ({
  width: props.width || 'fit-content',
  height: '1.875em',
  padding: '0 0 0 0.1875em',
  margin: '0 0.1875em',

  fontSize: '14px',
  lineHeight: '16px',
  background: 'transparent',
  color: palette.darkGray,
  border: 'none',
  borderRadius: '3px',
  outline: 0,
  boxShadow: 'none',
  WebkitAppearance: 'none',
  position: 'realative',

  '::placeholder': {
    color: palette.gray,
    fontSize: '11px',
  },
  ':focus': {
    border: 'none',
  },
}))

export const Placeholder = styled.p({
  color: palette.gray,
  fontSize: '11px',
  margin: '0 0.1875em',
  position: 'absolute',
})

export const ContentEditableElement = styled.div({
  outline: 0,
  border: 'none',
  whiteSpace: 'nowrap',
  padding: '0 0.46875em',
})

export const TagWrapper = styled.div((props) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  fontSize: '0.85em',
  lineHeight: 1,
  padding: '0 4px 0 8px',
  background: props.invalid
    ? setOpacity(palette.dullRed, 0.5)
    : palette.lightGray30,
  border: props.invalid
    ? `1px solid ${palette.danger}`
    : `1px solid ${palette.lightGray}`,
  boxSizing: 'border-box',
  borderRadius: '2px',
  height: '32px',
}))

export const ReadOnlyTag = styled.div({
  outline: 0,
  border: 'none',
  whiteSpace: 'nowrap',
  padding: '0 0.46875em',
})

export const TagRemove = styled.div((props) => ({
  position: 'relative',
  height: '2em',
  width: props.readOnly ? 0 : '1em',
  marginRight: '0.3em',

  fontSize: '1.1em',
  cursor: 'pointer',
  background: 'none',
  borderTopRightRadius: '3px',
  borderBottomRightRadius: '3px',

  ':before': {
    position: 'absolute',
    top: '50%',
    left: '50%',
    content: props.readOnly ? '' : `' '`,
    height: '0.9em',
    width: props.readOnly ? 0 : '1px',
    backgroundColor: palette.darkGray,
    transform: 'translateX(-50%) translateY(-50%) rotate(45deg)',
  },

  ':after': {
    position: 'absolute',
    top: '50%',
    left: '50%',
    content: props.readOnly ? '' : `' '`,
    height: '0.9em',
    width: props.readOnly ? 0 : '1px',
    backgroundColor: palette.darkGray,
    transform: 'translateX(-50%) translateY(-50%) rotate(-45deg)',
  },
}))

export const Description = styled.div((props) => ({
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: '12px',
  color: props.color || palette.darkGray50,
  fontFamily: fonts.primaryLight,
  margin: '10px 0',
}))
